import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import AddEditRollDialog from "../../../components/Dialog/AddEditRollDialog";
import DynamicTable from "../../../components/DynamicTable";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import TableData from "../../../dumyData/AdminRole.json";
import {
  createBusinessRole,
  fetchBusinessRole,
  updateRole,
} from "../../../services/Roles";
import { useSelector } from "react-redux";

const headerData = ["Name", "Action"];

const tableRows = ["role_name", "actions"];

function AllRolls({ setIsLoading = true }) {
  const openDialog = useRef();
  const { user } = useSelector((state) => state.user);
  const [businessRole, setBusinessRole] = useState([]);

  useEffect(() => {
    handleFetchRoles();
  }, []);

  const handleEditRole = (row, ind) => {
    openDialog.current.isVisible({ type: "edit", data: row });
  };

  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleFetchRoles = async () => {
    try {
      setIsLoading(true);
      const response = await fetchBusinessRole(user?._id);
      setIsLoading(false);
      if (response.status == 200 || response?.status == 201) {
        let data = response?.data?.data;
        setBusinessRole(data);
      } else {
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchRoles ~ error:", error);
    }
  };

  const handleCreateRole = async (rowData) => {
    try {
      setIsLoading(true);
      const response =
        rowData?.type == "edit"
          ? await updateRole(rowData?.roleId, rowData?.businessId, rowData)
          : await createBusinessRole(rowData);
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        handleSnackbarVal(true, "success", response.data.message);
        handleFetchRoles();
      } else {
        handleSnackbarVal(true, "error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleCreateRole ~ error:", error);
    }
  };

  const handleDelete = async (roleId) => {
    return;
    try {
      setIsLoading(true);
      const response = await []; // onDelete(roleId);
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        handleSnackbarVal(true, "success", response.data.message);
        handleFetchRoles();
      } else {
        handleSnackbarVal(true, "error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleCreateRole ~ error:", error);
    }
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"Create New Roles"}
            styleProps={{ fontWeight: 400, width: "auto" }}
            handleClickBtn={() =>
              openDialog.current.isVisible({ type: "add", data: {} })
            }
          />
        </Box>
      </Stack>
    );
  };

  return (
    <>
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <AppContainer
        primaryHeading={"Create Roles"}
        secondaryHeading={
          "View, edit and delete your created roles management."
        }
        headProps={renderRightPart()}
      >
        {businessRole?.length > 0 ? (
          <DynamicTable
            tableHeader={headerData}
            displayRows={tableRows}
            tableData={businessRole}
            showEdit={true}
            handleEdit={handleEditRole}
            handleDelete={(row) => handleDelete(row)}
          />
        ) : (
          <Stack height="100%" justifyContent="center">
            <Typography
              fontSize={18}
              fontWeight={800}
              color="#000"
              textAlign="center"
            >
              No Roles Found!
            </Typography>
          </Stack>
        )}
      </AppContainer>
      <AddEditRollDialog
        ref={openDialog}
        handleCreate={handleCreateRole}
        setIsLoading={setIsLoading}
      />
    </>
  );
}

export default AllRolls;
